import { useMemo as e } from "react";
//#region src/hooks/useMergeRefs.ts
var t = (e, t) => {
	if (e != null) {
		if (typeof e == "function") {
			e(t);
			return;
		}
		try {
			e.current = t;
		} catch {
			throw Error(`Cannot assign value '${t}' to ref '${e}'`);
		}
	}
}, n = (...e) => (n) => {
	e.forEach((e) => {
		t(e, n);
	});
}, r = (...t) => e(() => n(...t), t);
//#endregion
export { r as default };

//# sourceMappingURL=useMergeRefs.js.map